/**
 * plugins/webfontloader.js
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */

export async function loadFonts() {
  const webFontLoader = await import(
    /* webpackChunkName: "webfontloader" */ "webfontloader"
  );

  webFontLoader.load({
    google: {
      families: [
        "Playfair Display:400,500,600,700,800,900&display=swap",
        "Lato:300,400,700,900&display=swap",
        "Caveat:400,700&display=swap",
      ],
    },
  });
}
